export default __webpack_public_path__ + "static/media/case-li3.12c5ddd4.png";